import React, { useEffect, useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
export default function Contact() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [apiError, setApiError] = useState<string | null>(null);
  const [showToast, setShowToast] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setApiError(null);
    const newErrors: { [key: string]: string } = {};
    if (!formData.name.trim()) newErrors.name = 'Name is required';
    if (!formData.phone.trim()) newErrors.phone = 'Phone is required';
    if (formData.email && !/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(formData.email)) newErrors.email = 'Enter a valid email';
    if (!formData.message.trim()) newErrors.message = 'Message is required';
    if (formData.message && formData.message.length > 500) newErrors.message = 'Message must be 500 characters or less';

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;
    setIsSubmitting(true);
    setSubmitStatus('idle');
    try {
      const formBody = new URLSearchParams();
      formBody.append('name', formData.name);
      formBody.append('phone', formData.phone);
      formBody.append('email', formData.email);
      formBody.append('message', formData.message);
      const response = await fetch('/server/api/contact.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString(),
      });
      let ok = false;
      try {
        const json = await response.json();
        if (json && json.success) {
          ok = true;
        } else if (json && json.message) {
          setApiError(json.message);
        }
      } catch (e) {
        // non-json response
        if (response.ok) ok = true;
      }

      if (ok) {
        setSubmitStatus('success');
        setFormData({ name: '', phone: '', email: '', message: '' });
        setErrors({});
        setShowToast(true);
        window.setTimeout(() => setShowToast(false), 4000);
      } else {
        setSubmitStatus('error');
        if (!apiError) setApiError('Something went wrong. Please try again.');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <div className="min-h-screen bg-white">
      <Navbar isScrolled={isScrolled} />
      <section className="relative h-80 sm:h-[50vh] w-full overflow-hidden mt-20">
        <picture>
          <source media="(max-width: 768px)" srcSet="/assets/ContactUs-mobile.jpg" />
          <img
            src="/assets/ContactUs.jpg"
            alt="Contact Us"
            className="absolute inset-0 w-full h-full object-cover object-center"
          />
        </picture>
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
        <div className="relative h-full flex items-center justify-center">
          <div className="text-center px-4 sm:px-6">
            <div className="mb-4 inline-block">
              <div className="border-t-2 border-b-2 border-amber-400 py-2 px-4 sm:px-6">
                <span className="text-amber-300 text-xs sm:text-sm font-medium tracking-widest uppercase">
                  Get In Touch
                </span>
              </div>
            </div>
            <h1 className="text-3xl sm:text-5xl md:text-6xl font-bold text-white mb-4 leading-tight">
              Let's Bring Pure Water
              <br />
              to Every Home
            </h1>
          </div>
        </div>
      </section>
      <section className="py-16 sm:py-20 md:py-28 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 sm:gap-12 md:gap-16">
            <div>
              <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-amber-900 mb-6 md:mb-8">
                Contact Information
              </h2>
              <p className="text-gray-700 mb-8 sm:mb-10 leading-relaxed text-base sm:text-lg">
                We're here to answer your questions and help you find the perfect water storage
                solution for your needs. Reach out to us through any of the following channels.
              </p>
              <div className="space-y-6">
                <div className="group flex items-stretch gap-4 p-6 sm:p-7 bg-gradient-to-br from-amber-50 to-amber-50/50 rounded-2xl border-2 border-amber-100 hover:border-amber-400 shadow-md hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
                  <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-amber-600 rounded-xl flex-shrink-0 shadow-md group-hover:bg-amber-700 group-hover:shadow-lg transition-all duration-300">
                    <i className="ri-phone-line text-2xl sm:text-3xl text-white"></i>
                  </div>
                  <div className="flex flex-col justify-center flex-1">
                    <h3 className="font-bold text-amber-900 mb-1 text-lg">Phone / WhatsApp</h3>
                    <p className="text-gray-700 text-base">+91 99774 21070</p>
                    <p className="text-sm text-gray-600 mt-1">Mon-Sat: 9:00 AM- 6:00 PM</p>
                  </div>
                </div>
                <div className="group flex items-stretch gap-4 p-6 sm:p-7 bg-gradient-to-br from-amber-50 to-amber-50/50 rounded-2xl border-2 border-amber-100 hover:border-amber-400 shadow-md hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
                  <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-amber-600 rounded-xl flex-shrink-0 shadow-md group-hover:bg-amber-700 group-hover:shadow-lg transition-all duration-300">
                    <i className="ri-mail-line text-2xl sm:text-3xl text-white"></i>
                  </div>
                  <div className="flex flex-col justify-center flex-1">
                    <h3 className="font-bold text-amber-900 mb-1 text-lg">Email</h3>
                    <p className="text-gray-700 text-base">info@akshayrajindustry.com</p>
                    <p className="text-sm text-gray-600 mt-1">We'll respond within 24 hours</p>
                  </div>
                </div>
                <div className="group flex items-stretch gap-4 p-6 sm:p-7 bg-gradient-to-br from-amber-50 to-amber-50/50 rounded-2xl border-2 border-amber-100 hover:border-amber-400 shadow-md hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
                  <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-amber-600 rounded-xl flex-shrink-0 shadow-md group-hover:bg-amber-700 group-hover:shadow-lg transition-all duration-300">
                    <i className="ri-map-pin-line text-2xl sm:text-3xl text-white"></i>
                  </div>
                  <div className="flex flex-col justify-center flex-1">
                    <h3 className="font-bold text-amber-900 mb-1 text-lg">Address</h3>
                    <p className="text-gray-700 text-base leading-relaxed">
                      Akshayraj Industry Pvt. Ltd., Ujjain, Madhya Pradesh, India
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="lg:max-w-lg">
              <div className="bg-gradient-to-br from-amber-50 to-white p-6 sm:p-8 rounded-2xl shadow-lg border-2 border-amber-100">
                <h3 className="text-2xl sm:text-3xl font-bold text-amber-900 mb-6">Send Us a Message</h3>
                  <form id="contact-form" onSubmit={handleSubmit} data-readdy-form>
                    <div className="space-y-5">
                      <div>
                        <label htmlFor="name" className="block text-sm font-semibold text-amber-900 mb-2">
                          Name *
                        </label>
                        <input
                          type="text"
                          id="name"
                          name="name"
                          value={formData.name}
                          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                          required
                          className="w-full px-4 py-3 border-2 border-amber-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-600 focus:border-amber-600 text-sm transition-all duration-300"
                          placeholder="Your full name"
                        />
                          {errors.name && (
                            <p className="text-xs text-red-600 mt-1">{errors.name}</p>
                          )}
                      </div>
                      <div>
                        <label htmlFor="phone" className="block text-sm font-semibold text-amber-900 mb-2">
                          Phone *
                        </label>
                        <input
                          type="tel"
                          id="phone"
                          name="phone"
                          value={formData.phone}
                          onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                          required
                          className="w-full px-4 py-3 border-2 border-amber-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-600 focus:border-amber-600 text-sm transition-all duration-300"
                          placeholder="Your phone number"
                        />
                          {errors.phone && (
                            <p className="text-xs text-red-600 mt-1">{errors.phone}</p>
                          )}
                      </div>
                      <div>
                        <label htmlFor="email" className="block text-sm font-semibold text-amber-900 mb-2">
                          Email
                        </label>
                        <input
                          type="email"
                          id="email"
                          name="email"
                          value={formData.email}
                          onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                          className="w-full px-4 py-3 border-2 border-amber-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-600 focus:border-amber-600 text-sm transition-all duration-300"
                          placeholder="your@email.com"
                        />
                          {errors.email && (
                            <p className="text-xs text-red-600 mt-1">{errors.email}</p>
                          )}
                      </div>
                      <div>
                        <label htmlFor="message" className="block text-sm font-semibold text-amber-900 mb-2">
                          Message * (Max 500 characters)
                        </label>
                        <textarea
                          id="message"
                          name="message"
                          value={formData.message}
                          onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                          required
                          maxLength={500}
                          rows={5}
                          className="w-full px-4 py-3 border-2 border-amber-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-600 focus:border-amber-600 text-sm resize-none transition-all duration-300"
                          placeholder="Tell us about your requirements..."
                        />
                        <p className="text-xs text-gray-500 mt-1">
                          {formData.message.length}/500 characters
                        </p>
                        {errors.message && (
                          <p className="text-xs text-red-600 mt-1">{errors.message}</p>
                        )}
                      </div>
                      {apiError && (
                        <div className="p-4 bg-red-50 border-2 border-red-200 rounded-lg">
                          <p className="text-sm text-red-800 font-medium">{apiError}</p>
                        </div>
                      )}

                      <button
                        type="submit"
                        disabled={isSubmitting}
                        aria-busy={isSubmitting}
                        className="w-full px-6 py-4 bg-amber-600 hover:bg-amber-700 text-white font-semibold rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer text-lg"
                      >
                        {isSubmitting ? 'Sending...' : 'Send Message'}
                      </button>
                      {submitStatus === 'success' && (
                        <div className="p-4 bg-green-50 border-2 border-green-200 rounded-lg animate-pulse">
                          <p className="text-sm text-green-800 font-medium">
                            ✓ Thank you! Your message has been sent successfully.
                          </p>
                        </div>
                      )}
                      {submitStatus === 'error' && (
                        <div className="p-4 bg-red-50 border-2 border-red-200 rounded-lg">
                          <p className="text-sm text-red-800 font-medium">
                            ✕ Something went wrong. Please try again.
                          </p>
                        </div>
                      )}
                    </div>
                  </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="py-16 sm:py-20 md:py-28 bg-gradient-to-b from-white to-amber-50/30">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <h3 className="text-3xl sm:text-4xl font-bold text-amber-900 text-center mb-8 sm:mb-12">Find Us on Map</h3>
          <div className="rounded-2xl overflow-hidden shadow-2xl border-2 border-amber-100">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d468302.10102814407!2d75.60690129999999!3d23.510547000000003!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3964794a452ea601%3A0xca600630b8e1afc2!2sAKSHAYRAJ%20INDUSTRY%20PVT%20LTD!5e0!3m2!1sen!2sin!4v1772112028064!5m2!1sen!2sin"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Akshayraj Industry Location"
            ></iframe>
          </div>
        </div>
      </section>
      {/* Success toast */}
      {showToast && (
        <div className="fixed right-6 bottom-6 z-50">
          <div className="px-4 py-3 bg-green-600 text-white rounded-lg shadow-lg">
            <p className="text-sm">Message sent successfully.</p>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}